import {
	Box,
	Checkbox,
	FormControlLabel,
	Grid,
	TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import React from "react";
import { MyDialog } from "../../../../components/Dialog";
import { getTranslation } from "../../../../heplers/translationHelper";
import * as Yup from "yup";
import { MyTimePicker } from "../../../../components/TimePicker";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";
import { Post } from "../../../../actions";
import { Upsert_TimeSlots_URL } from "../../../../constants/apiUrls";
import { useSnackbar } from "notistack";
import moment from "moment";
import { format } from "../../../../heplers/format";
import { daysConstant } from "../../../../constants/general";
import dayjs from "dayjs";

const AddTimeSlotModal = ({
	open,
	handleClose,
	isEdit,
	setIsEdit,
	formData,
	setFormData,
	params,
	setParams,
	refreshTimeSlots,
}) => {
	let { primaryColor, secondaryColor } = params;
	if (typeof primaryColor === "undefined") primaryColor = "E7424C";
	if (typeof secondaryColor === "undefined") secondaryColor = "ffffff";

	const { enqueueSnackbar } = useSnackbar();
	// a slot belongs to the service of the open tab (0 midi, 1 soir); its time must match that service,
	// otherwise e.g. a 20:45 slot added on the midi tab shows among the midi slots
	// (only checked when adding: an existing slot cannot change service in this form)
	const EVENING_FROM_HOUR = 16;
	const slotDayTime = isEdit ? null : params.dayTime;
	const validationSchema = Yup.object().shape({
		startDateTime: Yup.string()
			.required(getTranslation("Start time is required"))
			.test("startDateTime", getTranslation("Start time must be 24 hours"), (value) => {
				// const { end_time } = this.parent;
				return moment(value).isValid();
			})
			.test(
				"startDateTimeService",
				slotDayTime === 1
					? getTranslation("An evening time slot must start at 16:00 or later. Add this time in the morning service.")
					: getTranslation("A morning time slot must start before 16:00. Add this time in the evening service."),
				(value) => {
					if (!moment(value).isValid() || (slotDayTime !== 0 && slotDayTime !== 1)) return true;
					const isEvening = moment(value).hour() >= EVENING_FROM_HOUR;
					return slotDayTime === 1 ? isEvening : !isEvening;
				}
			),
		endDateTime: Yup.string()
			.required(getTranslation("End time is required"))
			.test("endDateTime", getTranslation("End time must be 24 hours"), function (value) {
				// const { end_time } = this.parent;

				return moment(value).isValid();
			}),
		maxGroup: Yup.number().min(1, getTranslation("This field is required")),
		maxPersonPerGroup: Yup.number().min(1, getTranslation("This field is required")),
		comments: Yup.string(),
	});

	const addTimeSlot = async (payload, actions, isLast) => {
		console.log("kjasdsagdjhsagdjhsagdlsad",payload)
		await Post(
			payload,
			Upsert_TimeSlots_URL,
			null,
			(res) => {
				actions.setSubmitting(false);
				enqueueSnackbar(
					getTranslation(
						"Added Successfully",
						"Added Successfully",
						"Added Successfully"
					),
					{
						variant: "success",
					}
				);

				// setParams({ ...params, selectedDate: new Date(date), day: params.day });
				// setFormData({
				//   startDateTime: new Date(),
				//   endDateTime: new Date(),
				//   maxGroup: 0,
				//   maxPersonPerGroup: 0,
				//   comments: "",
				// });
				if (isLast) {
					handleClose(false);

					if (refreshTimeSlots) refreshTimeSlots();
				}
			},
			(err) => {
				if (!err) return;
				actions.setSubmitting(false);
				enqueueSnackbar(
					err?.data
						? err?.data
						: getTranslation(
								"Something went wrong",
								"Something went wrong",
								"Something went wrong"
						  ),
					{
						variant: "error",
					}
				);
			}
		);
	};

	// const modifyHours = (date) => {
	//   const newDate = new Date(date);
	//   newDate.setHours(newDate.getHours() + 1);
	//   const modifiedDate = new Date(newDate).toISOString();
	//   return modifiedDate;
	// };

	const onSubmit = (values, actions) => {
		// const startHour = new Date(modifyHours(values.startDateTime)).getHours();
		console.log("kjadssadjhaksdgjhagdahjd",values)
		actions.setSubmitting(true);
		// const dayTime = startHour > 12 ? 1 : 0;
		if (isEdit) {
			const payload = {
				...values,
				startDateTime: values.startDateTime,
				endDateTime: values.endDateTime,
			};
			addTimeSlot(payload, actions, i == values.selectedDays?.length - 1).then(
				() => {
					handleClose();
				}
			);
		} else {
			for (var i = 0; i < values.selectedDays?.length; i++) {
				const day = values.selectedDays[i];
				const payload = {
					...values,
					startDateTime:values.startDateTime,
					endDateTime: values.endDateTime,
					day: day.id,
					dayTime: params.dayTime,
				};
				addTimeSlot(payload, actions, i == values.selectedDays?.length - 1);
			}
		}

		// const payload = {
		//   ...values,
		//   startDateTime: moment(values.startDateTime).format("kk:mm"),
		//   endDateTime: moment(values.endDateTime).format("kk:mm"),
		//   day: params.day,
		//   dayTime: params.dayTime,
		// };
		// addTimeSlot(payload, actions);
	};

	return (
		<MyDialog
			title={
				isEdit
					? getTranslation(
							"Update Time Slot",
							"Update Time Slot",
							"Update Time Slot"
					  )
					: getTranslation("Add Time Slot", "Add Time Slot", "Add Time Slot")
			}
			open={open}
			onClose={() => handleClose(false)}
		>
			<div>
				<Formik
					initialValues={formData}
					enableReinitialize
					validationSchema={validationSchema}
					onSubmit={onSubmit}
				>
					{({
						values,
						errors,
						touched,
						handleChange,
						handleSubmit,
						setFieldValue,
						isSubmitting,
					}) => (
						<form onSubmit={handleSubmit}>
							{console.log("kajlshdjkahkjadadasd",formData.day)}
							<Grid container spacing={3}>
								{isEdit ||
									daysConstant.map((day, index) => {
										return (
											<Grid item sm={4} md={3} lg={2} key={index}>
												<FormControlLabel
													label={day.title.substring(0, 3)}
													name="selectedDays"
													onChange={(val) => {
														const { checked } = val.target;
														const arr = values.selectedDays;
														if (checked) {
															arr.push(day);
															setFieldValue("selectedDays", arr);
														} else
															setFieldValue(
																"selectedDays",
																arr.filter((x) => x.id != day.id)
															);
													}}
													control={
														<Checkbox
															checked={
																values?.selectedDays?.findIndex(
																	(x) => x.id == day.id
																) > -1
															}
															style={{ color: "#" + primaryColor }}
														/>
													}
												/>
												{touched.selectedDays && errors.selectedDays ? (
													<div>{errors.selectedDays}</div>
												) : null}
											</Grid>
										);
									})}
								{isEdit || (
									<Grid item sm={4} md={3} lg={2}>
										<FormControlLabel
											label={getTranslation("All")}
											name="selectedDays"
											onChange={(val) => {
												const { checked } = val.target;
												if (checked) {
													setFieldValue("selectedDays", daysConstant);
												} else setFieldValue("selectedDays", []);
											}}
											control={
												<Checkbox
													checked={
														values?.selectedDays?.length == daysConstant.length
													}
													style={{ color: "#" + primaryColor }}
												/>
											}
										/>
										{touched.selectedDays && errors.selectedDays ? (
											<div>{errors.selectedDays}</div>
										) : null}
									</Grid>
								)}
							</Grid>
							<br />
							<br />
							<Grid container spacing={4}>
								<Grid item sm={12} md={12} lg={6}>
									<MyTimePicker
										required
										size="small"
										ampm={false}
										label={getTranslation(
											"Start Time",
											"Start Time",
											"Start Time"
										)}
										value={values.startDateTime}
										onChange={(val) => {
											setFieldValue("startDateTime", dayjs(val).format("YYYY-MM-DDTHH:mm:ss"));
										}}
										inputVariant="standard"
										renderInput={(params) => <TextField {...params} />}
										id="startDateTime"
										name="startDateTime"
										error={
											touched.startDateTime && Boolean(errors.startDateTime)
										}
										helperText={touched.startDateTime && errors.startDateTime}
									/>
								</Grid>
								<Grid item sm={12} md={12} lg={6}>
									<MyTimePicker
										required
										// ampm={false}
										size="small"
										label={getTranslation("End Time", "End Time", "End Time")}
										value={values.endDateTime}
										onChange={(val) => {
											console.log("jkahdskjashdasdsad",val)
											setFieldValue("endDateTime", dayjs(val).format("YYYY-MM-DDTHH:mm:ss"));
										}}
										id="endDateTime"
										name="endDateTime"
										error={touched.endDateTime && Boolean(errors.endDateTime)}
										helperText={touched.endDateTime && errors.endDateTime}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={4}>
								<Grid item sm={12} md={12} lg={6}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="maxGroup"
										label={getTranslation(
											"Max Table",
											"Max Table",
											"Max Table"
										)}
										name="maxGroup"
										type="number"
										size="small"
										value={values.maxGroup}
										onChange={handleChange}
										error={touched.maxGroup && Boolean(errors.maxGroup)}
										helperText={touched.maxGroup && errors.maxGroup}
										InputProps={{ inputProps: { min: 0 } }}
									/>
								</Grid>
								<Grid item sm={12} md={12} lg={6}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="maxPersonPerGroup"
										label={getTranslation(
											"Max Person Per Table",
											"Max Person Per Table",
											"Max Person Per Table"
										)}
										name="maxPersonPerGroup"
										type="number"
										size="small"
										value={values.maxPersonPerGroup}
										onChange={handleChange}
										error={
											touched.maxPersonPerGroup &&
											Boolean(errors.maxPersonPerGroup)
										}
										helperText={
											touched.maxPersonPerGroup && errors.maxPersonPerGroup
										}
										InputProps={{ inputProps: { min: 0 } }}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={4}>
								<Grid item sm={12} md={12} lg={12}>
									<TextField
										variant="outlined"
										fullWidth
										minRows={5}
										multiline
										id="comments"
										label={getTranslation("Comment", "Comment", "Comment")}
										name="comments"
										type="string"
										size="small"
										value={values.comments}
										onChange={handleChange}
										error={touched.comments && Boolean(errors.comments)}
										helperText={touched.comments && errors.comments}
									/>
								</Grid>
							</Grid>
							<Box
								sx={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
									marginTop: "1rem",
								}}
							>
								<ButtonWithLoading
									title={getTranslation("Submit", "Submit", "Submit")}
									disabled={
										!isEdit
											? values.selectedDays.length == 0
											: false
											
									}
									type="submit"
									variant="contained"
									color="primary"
									textColor="white"
									loading={isSubmitting}
								/>
							</Box>
						</form>
					)}
				</Formik>
			</div>
		</MyDialog>
	);
};

export default AddTimeSlotModal;
